import { Page } from '../../types'

const criminalProsecutionsBribery: Page[] = [
    {
        pageType: 'question',
        title: 'Criminal prosecutions for bribery',
        name: 'criminal-prosecutions-bribery',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions were referred?',
                name: 'criminal-prosecutions-bribery-referred',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions proceeded to charge?',
                name: 'criminal-prosecutions-bribery-proceeded',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions were successful?',
                name: 'criminal-prosecutions-bribery-successful',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default criminalProsecutionsBribery
